import { forwardRef } from 'react';
import ObjectiveDetail from '../cardlistdetail/objective/ObjectiveDetail';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';
import './ObjectiveDetailPrint.scss';

const defaultProps = {
  included: [],
};

const ObjectiveDetailPrint = forwardRef((props, ref) => {
  const { objective, included, currentUser } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <div className='print-objective-detail-container' ref={ref}>
      <div className='name'>
        {currentUser?.firstName} {currentUser?.lastName}
      </div>
      <ObjectiveDetail objective={objective} included={included} />
    </div>
  );
});

export default ObjectiveDetailPrint;
